import { pause } from '@esentai/core/features/campaigns/actions';
import withAsyncRunner from '@esentai/core/hocs/withAsyncRunner';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import DeactivateButton from '@/components/ActionButtons/Deactivate';
import { canUpdateCampaign } from '@/features/campaignsPage/permissions';

const mapStateToProps = () => ({
  permission: canUpdateCampaign,
});

const mapDispatchToProps = (dispatch, { itemId }) => ({
  onClick: () => dispatch(pause(itemId)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withAsyncRunner({ runnerMethod: 'onClick' }),
)(DeactivateButton);
